module.exports = __webpack_public_path__ + "img/Nutricia-logo.5a0c3ad5.png";